






























import { Component, Vue } from 'vue-property-decorator';
import TextAreaField from '@/components/legacy/TextAreaField.vue';
import Button from '@/components/legacy/Button.vue';
import { ReviewsService } from '@/services/reviews.service';
import isMobile from '@/utils/isMobile';

@Component({
  components: {
    TextAreaField,
    Button,
  },
})
export default class ReviewView extends Vue {
  private userReview: string = '';
  private isMobileDevice: boolean = isMobile();

  private get negativeReviewPromptHeader(): string {
    return this.$store.getters['negativeReviewPromptHeader'];
  }
  private get negativeReviewPromptBody(): string {
    return this.$store.getters['negativeReviewPromptBody'];
  }
  private async sendReview() {
    const id = this.$store.state['reviewId'];
    if (id) {
      try {
        await ReviewsService.sendOpinion(this.userReview, id);
        this.$router.push({ name: 'negative' });
      } catch (err) {
        this.$router.push({ name: 'error' });
      }
    } else {
      this.$router.push({ name: 'error' });
    }
  }
}
